var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"demo-cw"},[_c('div',{staticClass:"main"},[_c('LessonCourseware',{attrs:{"class-type-id":_vm.classTypeId,"lesson-id":_vm.lessonId}})],1),_c('div',{staticClass:"btns"},[_c('a-button',{on:{"click":_vm.changeIds}},[_vm._v(" 切换课件 ")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }